
    import { Component, Prop, Vue} from 'vue-property-decorator'
    import echart01 from './common/echart01.vue'
    import echart02 from './common/echart02.vue'
    import echart03 from './common/echart03.vue'
    import echart04 from './common/echart04.vue'
    import echart05 from './common/echart05.vue'
    import echart07 from './common/echart07.vue'
    import echart08 from './common/echart08.vue'
    import echart09 from './common/echart09.vue'
    import echart11 from './common/echart11.vue'
    import echart12 from './common/echart12.vue'
    import echart13 from './common/echart13.vue'
    import echart15 from './common/echart15.vue'
    import dkwzXlgjMap from './common/dkwz-xlgj-map.vue'; //打卡位置-巡逻轨迹
    import ygdtdwMap from './common/ygdtdw-map.vue'; //员工动态定位
    import { formatTime } from "./common/formatTime.js"; //日期格式转换

    @Component({
        name:'kqtj',
        components:{
            echart01, echart02, echart03, echart04, echart05, echart07, echart08, echart09, echart11, echart12, echart13, echart15, dkwzXlgjMap, ygdtdwMap
        }
    })

    export default class hxkq extends Vue {
        //定时器
        timing= null
        //时分秒
        dateDay= null
        //年月日
        dateYear= null
        //星期几
        dateWeek= null
        //星期几
        weekday= ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
        bazs = []
        jrzgrs = []
        fwdws = []
        timerData = null
        dialogVisibleYgByzx = false
        dialogVisibleDdByzx = false
        dialogVisibleWmgd = false
        loadingHeader = false
        loadingHeaderJygydkqk = false
        viewData = {}
        viewDataJygydkqk = {
            data08 : ''
        }
        byzxList = []
        wmgdList = []
        byzxYgTableData = []
        byzxDdTableData = []
        loadingYgByzx = false
        wmgdTableData = []
        loadingDdByzx = false
        loadingWmgd = false
        byzxYgTableDataPhb = []
        byzxDdTableDataPhb =[]
        dialogVisibleByzxPhb = false
        wmgdTableDataPhb = []
        dialogVisibleWmgdPhb = false
        loadingByzxYgPhb = false
        loadingByzxDdPhb = false
        loadingWmgdPhb = false
        currentNoYgByzx = 1
        currentNoDdByzx = 1
        currentNoDdXqByzx = 1
        currentNoWmgd = 1
        pageSizeYgByzx = 10
        pageSizeDdByzx = 10
        pageSizeDdXqByzx = 10
        pageSizeWmgd = 10
        pageTotalYgByzx = 0
        pageTotalDdByzx = 0
        pageTotalDdXqByzx = 0
        pageTotalWmgd = 0
        byzxYhOrderType = 'DESC'
        byzxDdOrderType = 'DESC'
        byzxDdXqOrderType = 'DESC'
        wmgdOrderType = 'DESC'
        bmxx = ''
        mapBtnState = true
        showMapState = true

        mounted() {
            this.getData()
            this.getDataJygydkqk()
            this.getByzxTjSj()
            this.getWmgdTjSj()
            this.timeFn()
            this.timeData()
        }

        beforeDestroy() {
          //离开时删除计时器
          clearInterval(this.timing);
          clearInterval(this.timerData);
        }

        //右上角当前日期时间显示：每一秒更新一次最新时间
        timeFn() {
          this.timing = setInterval(() => {
            //获取当前时分秒
            this.dateDay = formatTime(new Date(), "HH: mm: ss");
            //获取当前年月日
            this.dateYear = formatTime(new Date(), "yyyy-MM-dd");
            //获取当前星期几
            this.dateWeek = this.weekday[new Date().getDay()];
          }, 1000);
        }

        timeData() {
            this.timerData = setInterval(() => {
                this.getTimerData()
            }, 60000);
        }

        getTimerData() {
            this.$request({
                url: '/bjba/dp/getTimerData',
                method: 'get',
                params: {  }
            })
            .then(response => {
                console.log("定时获取的数据为：",response)
                var bazs = response.data.bazsCount + '';
                this.bazs = bazs.split('')
                var zgrs = response.data.zgrs + '';
                this.jrzgrs = zgrs.split('')
                var fwdwCount = response.data.fwdwCount + '';
                this.fwdws = fwdwCount.split('')
            })
            .catch(error => {
                console.log(error)
            })
        }

        getData() {
            this.loadingHeader =true;
            this.$request({
                url: '/bjba/homePage/getViewData',
                method: 'get',
                params: {  }
            })
            .then(response => {
                console.log(response)
                this.viewData = response.data.data
                let nvbl = [{name:response.data.data.nnbl[0].NAME,value:response.data.data.nnbl[0].VALUE},{name:response.data.data.nnbl[1].NAME,value:response.data.data.nnbl[1].VALUE}]
                this.viewData.data01=nvbl
                let baznnbl = [{name:response.data.data.baznnbl[1].NAME,value:response.data.data.baznnbl[1].VALUE},{name:response.data.data.baznnbl[0].NAME,value:response.data.data.baznnbl[0].VALUE}]
                this.viewData.data02=baznnbl
                this.viewData.data04=response.data.data.jsnbabh
                this.viewData.data05=response.data.data.jsnfwdwbh
                this.viewData.data06=response.data.data.dwwcd
                this.viewData.data07=response.data.data.badtgl
                let lrtj = [{name:response.data.data.lrtj[1].name,value:response.data.data.lrtj[1].value},{name:response.data.data.lrtj[0].name,value:response.data.data.lrtj[0].value}]
                this.viewData.datalrtj=lrtj
                this.viewData.data12 = response.data.data.ydrgcb
                this.viewData.data13=response.data.data.fkdjxx
                this.viewData.data14=response.data.data.zcxx
                let gqzb = [{name:response.data.data.gqzb[1].name,value:response.data.data.gqzb[1].value},{name:response.data.data.gqzb[0].name,value:response.data.data.gqzb[0].value}]
                this.viewData.data15=gqzb
                var bazs = response.data.data.bazsCount + '';
                this.bazs = bazs.split('')
                var zgrs = response.data.data.zgrs + '';
                this.jrzgrs = zgrs.split('')
                var fwdwCount = response.data.data.fwdwCount + '';
                this.fwdws = fwdwCount.split('')
                this.loadingHeader = false;
            })
            .catch(error => {
                console.log(error)
            })
        }

        getDataJygydkqk() {
            let _this =this;
            _this.loadingHeaderJygydkqk = true;
            this.$request({
                url: '/bjba/homePage/getViewDataJygydkqk',
                method: 'get'
            })
            .then(response => {
                console.log(response)
                _this.viewDataJygydkqk.data08 = response.data.data.jygydkqk
                _this.loadingHeaderJygydkqk = false;
            })
            .catch(error => {
                console.log(error)
            })
        }

        handleSizeChangeYgByzx(val) {
            this.pageSizeYgByzx = val;
            this.byzxYgAll();
        }
        handleCurrentChangeYgByzx(val) {
            this.currentNoYgByzx = val;
            this.byzxYgAll();
        }
        handleSizeChangeDdByzx(val) {
            this.pageSizeDdByzx = val;
            this.byzxDdAll()
        }
        handleCurrentChangeDdByzx(val) {
            this.currentNoDdByzx = val;
            this.byzxDdAll()
        }
        handleSizeChangeDdXqByzx(val) {
            this.pageSizeDdXqByzx = val;
            this.byzxDdXq(this.bmxx)
        }
        handleCurrentChangeDdXqByzx(val) {
            this.currentNoDdXqByzx = val;
            this.byzxDdXq(this.bmxx)
        }
        handleSizeChangeWmgd(val) {
            this.pageSizeWmgd = val;
            this.wmgdAll();
        }
        handleCurrentChangeWmgd(val) {
            this.currentNoWmgd = val;
            this.wmgdAll();
        }

        byzxYgHandleTableSort({ column }) {
            console.log("点击排序按钮：",column.order)
            if (column.order) {
                if (column.order == 'ascending') {
                    this.byzxYhOrderType = 'ASC'
                    this.byzxYgAll()
                } else {
                    this.byzxYhOrderType = 'DESC'
                    this.byzxYgAll()
                }
            } else {
                this.byzxYhOrderType = 'DESC'
                this.byzxYgAll()
            }
        }
        byzxDdHandleTableSort({ column }) {
            console.log("点击排序按钮：",column.order)
            if (column.order) {
                if (column.order == 'ascending') {
                    this.byzxDdOrderType = 'ASC'
                    this.byzxDdAll()
                } else {
                    this.byzxDdOrderType = 'DESC'
                    this.byzxDdAll()
                }
            } else {
                this.byzxDdOrderType = 'DESC'
                this.byzxDdAll()
            }
        }
        byzxDdXqHandleTableSort({ column }) {
            console.log("点击排序按钮：",column.order)
            if (column.order) {
                if (column.order == 'ascending') {
                    this.byzxDdXqOrderType = 'ASC'
                    this.byzxDdXq(this.bmxx)
                } else {
                    this.byzxDdXqOrderType = 'DESC'
                    this.byzxDdXq(this.bmxx)
                }
            } else {
                this.byzxDdXqOrderType = 'DESC'
                this.byzxDdXq(this.bmxx)
            }
        }
        wmgdHandleTableSort({ column }) {
            console.log("点击排序按钮：",column.order)
            if (column.order) {
                if (column.order == 'ascending') {
                    this.wmgdOrderType = 'ASC'
                    this.wmgdAll()
                } else {
                    this.wmgdOrderType = 'DESC'
                    this.wmgdAll()
                }
            } else {
                this.wmgdOrderType = 'DESC'
                this.wmgdAll()
            }
        }

        getByzxTjSj(){
            this.$request({
                url: '/bjba/byzxwmgd/getByzxTjSj',
                method: 'get',
                params: { page: 1, size: 3, order: this.byzxYhOrderType }
            })
            .then(response => {
                this.byzxList = response.data.data
            })
            .catch(error => {
                console.log(error)
            })
        }

        getWmgdTjSj(){
            this.$request({
                url: '/bjba/byzxwmgd/getWmgdTjSj',
                method: 'get',
                params: { page: 0, size:3, order: this.wmgdOrderType }
            })
            .then(response => {
                this.wmgdList = response.data.data
            })
            .catch(error => {
                console.log(error)
            })
        }

        byzxYgXq(id: String){
            this.loadingYgByzx = true
            this.$request({
                url: '/bjba/byzxwmgd/getByzxTjXqXx?id='+id,
                method: 'get',
                })
                .then(response => {
                    this.byzxYgTableData = response.data
                    this.loadingYgByzx = false
                })
                .catch(error => {
                    this.loadingYgByzx = false
                    console.log(error)
                })
        }

        byzxYgAll() {
            this.dialogVisibleByzxPhb = true
            this.loadingByzxYgPhb = true
            this.$request({
                    url: '/bjba/byzxwmgd/getByzxTjSj',
                    method: 'get',
                    params: { page: this.currentNoYgByzx, size:this.pageSizeYgByzx, order: this.byzxYhOrderType }
                })
                .then(response => {
                    this.byzxYgTableDataPhb = response.data.data
                    this.pageTotalYgByzx = response.data.total
                    this.loadingByzxYgPhb = false
                })
                .catch(error => {
                    this.loadingByzxYgPhb = false
                    console.log(error)
                })
        }

        byzxDdXq(bm){
            if(this.bmxx != bm) {
                this.currentNoDdXqByzx=1
                this.pageSizeDdXqByzx=10
            }
            this.bmxx = bm
            this.loadingDdByzx = true
            this.$request({
                    url: '/bjba/byzxwmgd/getDdTjXqXx',
                    method: 'get',
                    params: {bm: bm, page: (this.currentNoDdXqByzx-1)*this.pageSizeDdXqByzx, size: this.currentNoDdXqByzx*this.pageSizeDdXqByzx, order: this.byzxDdXqOrderType  }
                })
                .then(response => {
                    this.byzxDdTableData = response.data.data
                    this.pageTotalDdXqByzx = response.data.total
                    this.loadingDdByzx = false
                })
                .catch(error => {
                    this.loadingDdByzx = false
                    console.log(error)
                })
        }

        byzxDdAll() {
            this.loadingByzxDdPhb = true
            this.$request({
                    url: '/bjba/byzxwmgd/getDdTjSj',
                    method: 'get',
                    params: { page: (this.currentNoDdByzx-1)*this.pageSizeDdByzx, size: this.currentNoDdByzx*this.pageSizeDdByzx, order: this.byzxDdOrderType  }
                })
                .then(response => {
                    this.byzxDdTableDataPhb = response.data.data
                    this.pageTotalDdByzx = response.data.total
                    this.loadingByzxDdPhb = false
                })
                .catch(error => {
                    this.loadingByzxDdPhb = false
                    console.log(error)
                })
        }

        wmgdxq(gdmc: String){
            this.loadingWmgd = true
            this.$request({
                url: '/bjba/byzxwmgd/getWmgdTjXqXx?gdmc='+gdmc,
                method: 'get'
                })
                .then(response => {
                    this.wmgdTableData = response.data
                    this.loadingWmgd = false
                })
                .catch(error => {
                    this.loadingWmgd = false
                    console.log(error)
                })
        }

        wmgdAll(){
            this.dialogVisibleWmgdPhb = true
            this.loadingWmgdPhb = true
            this.$request({
                    url: '/bjba/byzxwmgd/getWmgdTjSj',
                    method: 'get',
                    params: { page: (this.currentNoWmgd-1)*this.pageSizeWmgd, size: this.currentNoWmgd*this.pageSizeWmgd, order: this.wmgdOrderType }
                })
                .then(response => {
                    this.wmgdTableDataPhb = response.data.data
                    this.pageTotalWmgd = response.data.total
                    this.loadingWmgdPhb = false
                })
                .catch(error => {
                    this.loadingWmgdPhb = false
                    console.log(error)
                })
        }

        ygdkwz() {
            console.log("点击员工打卡信息")
            this.showMapState = true
        }

        ygdtwz() {
            console.log("点击员工动态位置")
            this.showMapState = false
        }

        clickMapData(data: String) {
            console.log("点击地图，首页获取的数据为：",data)
            if (data == '标记点') {
                this.mapBtnState = false
            } else if (data == '返回') {
                this.mapBtnState = true
            }
        }
    }
